import "../styles/Navbar.css";
import logo from "../styles/logo.png";
import React, { useState } from "react";
import NotificationDialog from "./components/NotificationDialog";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import useBodyScrollLock from "../hooks/useBodyScrollLock";

function Navbar() {
  const navigate = useNavigate();

  const [showNotificationDialog, setShowNotificationDialog] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useBodyScrollLock(menuOpen);

  const navItems = [
    { to: "/admin-dashboard", label: "Home" },
    { to: "/castingcalls", label: "Notices" },
    { to: "/post-casting-call", label: "Post a Job" },
    { to: "/notification-list", label: "Banners" },
    { to: "/admin/user-list", label: "User List" },
    { to: "/admin/questions", label: "Q&A" },
    { to: "/search", label: "Search Talent" },
  ];

  const handleLogout = () => {
    const rememberedUsername = localStorage.getItem("rememberedUsername");

    localStorage.removeItem("userId");
    localStorage.removeItem("token");
    localStorage.removeItem("loggedInUser");
    localStorage.removeItem("email");
    localStorage.removeItem("userRole");

    if (rememberedUsername) {
      localStorage.setItem("rememberedUsername", rememberedUsername);
    }

    localStorage.setItem("logout", Date.now());

    navigate("/login");
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* LEFT */}
        <div className="navbar-left">
          <img src={logo} alt="DirectSubmit Logo" className="logo-img" />

          <div className="nav-links">
            {navItems.map((item) => (
              <Link key={item.to} to={item.to} className="nav-link">
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <div className="navbar-right nav-links">
          <button className="sign-out-btn" onClick={handleLogout}>
            Sign Out
          </button>
        </div>

        {/* MOBILE ICON */}
        <div
          className="hamburger-icon"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="navbar-bottom">
        <div className="navbar-left"></div>

        <div className="navBarCenter"></div>

        <div className="navbar-right">
          <Link to="/account" className="bottom-link">
            Edit Account
          </Link>

          <Link to="/contact" className="bottom-link">
            Help / Contact
          </Link>
        </div>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="mobile-menu">
          <button
            className="mobile-menu-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            <FaTimes />
          </button>

          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="mobile-link"
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}

          <Link
            to="/account"
            className="mobile-link"
            onClick={() => setMenuOpen(false)}
          >
            Edit Account
          </Link>

          <Link
            to="/contact"
            className="mobile-link"
            onClick={() => setMenuOpen(false)}
          >
            Help / Contact
          </Link>

          <button className="mobile-signout" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      )}

      {showNotificationDialog && (
        <NotificationDialog
          open={showNotificationDialog}
          onClose={() => setShowNotificationDialog(false)}
        />
      )}
    </nav>
  );
}

export default Navbar;